export default "__VITE_ASSET__d5250e20__"